import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import NewsAndEvents from '../views/NewsAndEvents.vue'
import About from '../views/About.vue'
import Content from '../views/Content.vue'
import Opportunities from '../views/Opportunities.vue'
import Contact from '../views/Contact.vue'
import PrivacyAndPolicy from '../views/PrivacyAndPolicy.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import MemberDirectory from '../views/MemberDirectory.vue'
import MemberBenefits from '../views/MemberBenefits.vue'
import BecomeMember from '../views/BecomeMember.vue'
import News from '../views/News.vue'
import Events from '../views/Events.vue'

const routes = [
  {
    path: '/',
    alias: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Australian Alumni Association of Cambodia - AAA-C',
      description: 'AAA-C connects Australian alumni in Cambodia through membership, news, events, opportunities, and community programs.',
      canonical: '/'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'About Us - AAA-C',
      description: 'Learn about the Australian Alumni Association of Cambodia, its mission, leadership, and alumni community.',
      canonical: '/about'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Member Login - AAA-C',
      description: 'Log in to access AAA-C member features, profile updates, notifications, and membership services.',
      canonical: '/login',
      robots: 'noindex,nofollow'
    }

  },
  {
    path: '/news_and_events',
    name: 'NewsAndEvents',
    component: NewsAndEvents,
    meta: {
      title: 'News & Events - AAA-C',
      description: 'Read the latest AAA-C news, community updates, events, and opportunities for Australian alumni in Cambodia.',
      canonical: '/news_and_events'
    }
  },
  {
    path: '/content/:slug_url',
    name: 'Content',
    component: Content,
    meta: {
      title: 'Content - AAA-C',
      description: 'Read AAA-C updates, announcements, news, events, and opportunities.',
      canonical: route => `/content/${route.params.slug_url}`
    }
  },
  {
    path: "/opportunities",
    name: 'Opportunities',
    component: Opportunities,
    meta: {
      title: 'Opportunities - AAA-C',
      description: 'Explore opportunities shared with the AAA-C alumni community in Cambodia.',
      canonical: '/opportunities'
    }
  },
  {
    path: '/contact_us',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Contact Us - AAA-C',
      description: 'Contact AAA-C for membership questions, alumni support, partnerships, and general enquiries.',
      canonical: '/contact_us'
    }
  },
  {
    path: '/privacy_and_policy',
    name: 'Privacy and Policy',
    component: PrivacyAndPolicy,
    meta: {
      title: 'Privacy Policy - AAA-C',
      description: 'Review the AAA-C privacy policy and how member and visitor information is handled.',
      canonical: '/privacy_and_policy'
    }
  },
  {
    path: '/terms_and_conditions',
    name: 'Terms and Conditons',
    component: TermsAndConditions,
    meta: {
      title: 'Terms and Conditions - AAA-C',
      description: 'Review the terms and conditions for using AAA-C services and membership features.',
      canonical: '/terms_and_conditions'
    }
  },
  {
    path: '/member_directory',
    name: 'Member Directory',
    component: MemberDirectory,
    meta: {
      title: 'Member Directory - AAA-C',
      description: 'Browse the AAA-C member directory and connect with Australian alumni in Cambodia.',
      canonical: '/member_directory'
    }
  },
  {
    path: '/membership_benefit',
    name: 'Member Benefits',
    component: MemberBenefits,
    meta: {
      title: 'Member Benefits - AAA-C',
      description: 'Discover benefits available to AAA-C members and Australian alumni in Cambodia.',
      canonical: '/membership_benefit'
    }
  },
  {
    path: '/become_a_member',
    name: 'Become a Member',
    component: BecomeMember,
    meta: {
      title: 'Become a Member - AAA-C',
      description: 'Join AAA-C to connect with Australian alumni in Cambodia and access member benefits.',
      canonical: '/become_a_member'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: 'News - AAA-C',
      description: 'Read AAA-C news and updates for the Australian alumni community in Cambodia.',
      canonical: '/news'
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: {
      title: 'Events - AAA-C',
      description: 'Find AAA-C events and activities for Australian alumni and partners in Cambodia.',
      canonical: '/events'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
